import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Feature, RoomCommands, RoomProperties } from '@vi-iot/client';
import { CommissioningService } from '../commissioning.service';
import { InstallationFeaturesStore } from '../../../../../@store';

@Component({
  selector: 'app-commissioning-delete-room-confirm-modal',
  templateUrl: './commissioning-delete-room-confirm-modal.component.html',
  styleUrls: ['./commissioning-delete-room-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommissioningDeleteRoomConfirmModalComponent implements OnInit {
  readonly TITLE_KEY = '+SRC_COMMISSIONINGV2.DELETE_ROOM_TITLE';
  readonly NORMAL_MESSAGE_KEY = '+SRC_COMMISSIONINGV2.DELETE_ROOM_CONFIRM_TEXT';
  readonly LAST_DEVICE_MESSAGE_KEY = '+SRC_COMMISSIONINGV2.DELETE_ROOM_LAST_DEVICE_CONFIRM_TEXT';

  shouldDeactivateSRC = false;

  constructor(
    public dialogRef: MatDialogRef<CommissioningDeleteRoomConfirmModalComponent>,
    public commissioningService: CommissioningService,
    public installationFeaturesStore: InstallationFeaturesStore,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      room: Feature<RoomProperties, RoomCommands>;
      titleKey?: string;
      normalMessageKey?: string;
      lastDeviceMessageKey?: string;
      isOtherRoom?: boolean;
    }
  ) {}

  ngOnInit(): void {
    this.dialogRef.updateSize('720px');
  }

  getTitleMessageKey(): string {
    return this.data?.titleKey ? this.data.titleKey : this.TITLE_KEY;
  }

  getNormalMessageKey(): string {
    return this.data?.normalMessageKey ? this.data.normalMessageKey : this.NORMAL_MESSAGE_KEY;
  }

  getLastDeviceMessageKey(): string {
    this.shouldDeactivateSRC = true;

    return this.data?.lastDeviceMessageKey
      ? this.data.lastDeviceMessageKey
      : this.LAST_DEVICE_MESSAGE_KEY;
  }

  isRoomWithOneDevice(): boolean {
    return this.data.room?.properties?.actors?.value?.length === 1;
  }

  onCancel(): void {
    this.dialogRef.close({
      confirmed: false,
      shouldDeactivateSRC: false,
    });
  }

  onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      shouldDeactivateSRC: this.shouldDeactivateSRC,
    });
  }
}
